import { render, staticRenderFns } from "./NotifyDialog.vue?vue&type=template&id=40a4d342&scoped=true"
import script from "./NotifyDialog.vue?vue&type=script&lang=js"
export * from "./NotifyDialog.vue?vue&type=script&lang=js"
import style0 from "./NotifyDialog.vue?vue&type=style&index=0&id=40a4d342&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a4d342",
  null
  
)

export default component.exports